// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__M2-mG","list":"Menu_list__kZX7G","menu-link":"Menu_menu-link__G2qY2","row":"Menu_row__Ujdr+","menu-button":"Menu_menu-button__qxagj"};